export default __webpack_public_path__ + "static/media/can1.a8a5aac2.jpeg";